import styled, { css } from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: ${({ isColumn }) =>
    isColumn ? '1fr' : 'repeat(3, 1fr)'};
  gap: 5px;
  ${respondTo.desktop`
    gap: ${({ isColumn,gap }) => (isColumn ? gap? gap:15 : 30)}px;
  `}
  ${respondTo.mobile`
    // gap: 20px;
  `}
  ${({ onlyNative }) => onlyNative && css`
    gap: 20px;
  `}
`;
